export const REQUEST_PROVIDER_SIGNUP = "REQUEST_PROVIDER_SIGNUP"
export const PROVIDER_SIGNUP_SUCCESS = "PROVIDER_SIGNUP_SUCCESS"
export const PROVIDER_SIGNUP_FAILED = "PROVIDER_SIGNUP_FAILED"
export const EDIT_TENANT_FAILED = "EDIT_TENANT_FAILED"
export const GET_TENANTS_REQUEST = "GET_TENANTS_REQUEST"
export const TENANTS_REQUEST_SUCCESS = "TENANTS_REQUEST_SUCCESS"
export const TENANTS_REQUEST_FAILED= "TENANTS_REQUEST_FAILED"
export const EDIT_TENANT = "EDIT_TENANT"
export const MAKE_FORM_EMPTY = "MAKE_FORM_EMPTY"
export const EDIT_TENANT_STATUS ="EDIT_TENANT_STATUS"
export const EDIT_TENANT_SUCCESS = 'EDIT_TENANT_SUCCESS';
export const GET_PROVIDER_PROFILE_SUCCESS = 'GET_PROVIDER_PROFILE_SUCCESS';
export const GET_PROVIDER_PROFILE_FAILED = 'GET_PROVIDER_PROFILE_FAILED';
export const GET_PROVIDER_PROFILE_REQUEST = 'GET_PROVIDER_PROFILE_REQUEST';



///////auth////////////

export const GET_USER_SUCCESS =  "GET_USER_SUCCESS"
export const GET_USER_FAILED =  "GET_USER_FAILED"
export const USER_LOGOUT =  "USER_LOGOUT"


